"use strict";
import c from "./index.es109.js";
function i(t) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(o) {
    return n[o];
  });
}
function u(t, n) {
  this._pairs = [], t && c(t, this, n);
}
const r = u.prototype;
r.append = function(t, n) {
  this._pairs.push([t, n]);
};
r.toString = function(t) {
  const n = t ? function(o) {
    return t.call(this, o, i);
  } : i;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
export {
  u as default
};
//# sourceMappingURL=index.es168.js.map
